"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.circular = circular;
exports["default"] = void 0;
exports.fromCircle = fromCircle;
exports.fromExtent = fromExtent;
exports.makeRegular = makeRegular;

var _GeometryLayout = _interopRequireDefault(require("./GeometryLayout.js"));

var _GeometryType = _interopRequireDefault(require("./GeometryType.js"));

var _LinearRing = _interopRequireDefault(require("./LinearRing.js"));

var _Point = _interopRequireDefault(require("./Point.js"));

var _SimpleGeometry = _interopRequireDefault(require("./SimpleGeometry.js"));

var _closest = require("./flat/closest.js");

var _extent = require("../extent.js");

var _deflate = require("./flat/deflate.js");

var _array = require("../array.js");

var _interiorpoint = require("./flat/interiorpoint.js");

var _inflate = require("./flat/inflate.js");

var _intersectsextent = require("./flat/intersectsextent.js");

var _orient = require("./flat/orient.js");

var _area = require("./flat/area.js");

var _contains = require("./flat/contains.js");

var _math = require("../math.js");

var _simplify = require("./flat/simplify.js");

var _sphere = require("../sphere.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/geom/Polygon
 */


/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */
var Polygon =
/** @class */
function (_super) {
  __extends(Polygon, _super);
  /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `opt_layout` and `opt_ends` are also accepted.)
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @param {Array<number>} [opt_ends] Ends (for internal use with flat coordinates).
   */


  function Polygon(coordinates, opt_layout, opt_ends) {
    var _this = _super.call(this) || this;
    /**
     * @type {Array<number>}
     * @private
     */


    _this.ends_ = [];
    /**
     * @private
     * @type {number}
     */

    _this.flatInteriorPointRevision_ = -1;
    /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */

    _this.flatInteriorPoint_ = null;
    /**
     * @private
     * @type {number}
     */

    _this.maxDelta_ = -1;
    /**
     * @private
     * @type {number}
     */

    _this.maxDeltaRevision_ = -1;
    /**
     * @private
     * @type {number}
     */

    _this.orientedRevision_ = -1;
    /**
     * @private
     * @type {Array<number>}
     */

    _this.orientedFlatCoordinates_ = null;

    if (opt_layout !== undefined && opt_ends) {
      _this.setFlatCoordinates(opt_layout,
      /** @type {Array<number>} */
      coordinates);

      _this.ends_ = opt_ends;
    } else {
      _this.setCoordinates(
      /** @type {Array<Array<import("../coordinate.js").Coordinate>>} */
      coordinates, opt_layout);
    }

    return _this;
  }
  /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */


  Polygon.prototype.appendLinearRing = function (linearRing) {
    if (!this.flatCoordinates) {
      this.flatCoordinates = linearRing.getFlatCoordinates().slice();
    } else {
      (0, _array.extend)(this.flatCoordinates, linearRing.getFlatCoordinates());
    }

    this.ends_.push(this.flatCoordinates.length);
    this.changed();
  };
  /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   */


  Polygon.prototype.clone = function () {
    var polygon = new Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
    polygon.applyProperties(this);
    return polygon;
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */


  Polygon.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
    if (minSquaredDistance < (0, _extent.closestSquaredDistanceXY)(this.getExtent(), x, y)) {
      return minSquaredDistance;
    }

    if (this.maxDeltaRevision_ != this.getRevision()) {
      this.maxDelta_ = Math.sqrt((0, _closest.arrayMaxSquaredDelta)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
      this.maxDeltaRevision_ = this.getRevision();
    }

    return (0, _closest.assignClosestArrayPoint)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
  };
  /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */


  Polygon.prototype.containsXY = function (x, y) {
    return (0, _contains.linearRingsContainsXY)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
  };
  /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */


  Polygon.prototype.getArea = function () {
    return (0, _area.linearRings)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
  };
  /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [opt_right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   */


  Polygon.prototype.getCoordinates = function (opt_right) {
    var flatCoordinates;

    if (opt_right !== undefined) {
      flatCoordinates = this.getOrientedFlatCoordinates().slice();
      (0, _orient.orientLinearRings)(flatCoordinates, 0, this.ends_, this.stride, opt_right);
    } else {
      flatCoordinates = this.flatCoordinates;
    }

    return (0, _inflate.inflateCoordinatesArray)(flatCoordinates, 0, this.ends_, this.stride);
  };
  /**
   * @return {Array<number>} Ends.
   */


  Polygon.prototype.getEnds = function () {
    return this.ends_;
  };
  /**
   * @return {Array<number>} Interior point.
   */


  Polygon.prototype.getFlatInteriorPoint = function () {
    if (this.flatInteriorPointRevision_ != this.getRevision()) {
      var flatCenter = (0, _extent.getCenter)(this.getExtent());
      this.flatInteriorPoint_ = (0, _interiorpoint.getInteriorPointOfArray)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
      this.flatInteriorPointRevision_ = this.getRevision();
    }

    return this.flatInteriorPoint_;
  };
  /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */


  Polygon.prototype.getInteriorPoint = function () {
    return new _Point["default"](this.getFlatInteriorPoint(), _GeometryLayout["default"].XYM);
  };
  /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */


  Polygon.prototype.getLinearRingCount = function () {
    return this.ends_.length;
  };
  /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */


  Polygon.prototype.getLinearRing = function (index) {
    if (index < 0 || this.ends_.length <= index) {
      return null;
    }

    return new _LinearRing["default"](this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
  };
  /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */


  Polygon.prototype.getLinearRings = function () {
    var layout = this.layout;
    var flatCoordinates = this.flatCoordinates;
    var ends = this.ends_;
    var linearRings = [];
    var offset = 0;

    for (var i = 0, ii = ends.length; i < ii; ++i) {
      var end = ends[i];
      var linearRing = new _LinearRing["default"](flatCoordinates.slice(offset, end), layout);
      linearRings.push(linearRing);
      offset = end;
    }

    return linearRings;
  };
  /**
   * @return {Array<number>} Oriented flat coordinates.
   */


  Polygon.prototype.getOrientedFlatCoordinates = function () {
    if (this.orientedRevision_ != this.getRevision()) {
      var flatCoordinates = this.flatCoordinates;

      if ((0, _orient.linearRingsAreOriented)(flatCoordinates, 0, this.ends_, this.stride)) {
        this.orientedFlatCoordinates_ = flatCoordinates;
      } else {
        this.orientedFlatCoordinates_ = flatCoordinates.slice();
        this.orientedFlatCoordinates_.length = (0, _orient.orientLinearRings)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
      }

      this.orientedRevision_ = this.getRevision();
    }

    return this.orientedFlatCoordinates_;
  };
  /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   */


  Polygon.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
    var simplifiedFlatCoordinates = [];
    var simplifiedEnds = [];
    simplifiedFlatCoordinates.length = (0, _simplify.quantizeArray)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
    return new Polygon(simplifiedFlatCoordinates, _GeometryLayout["default"].XY, simplifiedEnds);
  };
  /**
   * Get the type of this geometry.
   * @return {import("./GeometryType.js").default} Geometry type.
   * @api
   */


  Polygon.prototype.getType = function () {
    return _GeometryType["default"].POLYGON;
  };
  /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */


  Polygon.prototype.intersectsExtent = function (extent) {
    return (0, _intersectsextent.intersectsLinearRingArray)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
  };
  /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
   * @api
   */


  Polygon.prototype.setCoordinates = function (coordinates, opt_layout) {
    this.setLayout(opt_layout, coordinates, 2);

    if (!this.flatCoordinates) {
      this.flatCoordinates = [];
    }

    var ends = (0, _deflate.deflateCoordinatesArray)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
    this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
    this.changed();
  };

  return Polygon;
}(_SimpleGeometry["default"]);

var _default = Polygon;
/**
 * Create an approximation of a circle on the surface of a sphere.
 * @param {import("../coordinate.js").Coordinate} center Center (`[lon, lat]` in degrees).
 * @param {number} radius The great-circle distance from the center to
 *     the polygon vertices in meters.
 * @param {number} [opt_n] Optional number of vertices for the resulting
 *     polygon. Default is `32`.
 * @param {number} [opt_sphereRadius] Optional radius for the sphere (defaults to
 *     the Earth's mean radius using the WGS84 ellipsoid).
 * @return {Polygon} The "circular" polygon.
 * @api
 */

exports["default"] = _default;

function circular(center, radius, opt_n, opt_sphereRadius) {
  var n = opt_n ? opt_n : 32;
  /** @type {Array<number>} */

  var flatCoordinates = [];

  for (var i = 0; i < n; ++i) {
    (0, _array.extend)(flatCoordinates, (0, _sphere.offset)(center, radius, 2 * Math.PI * i / n, opt_sphereRadius));
  }

  flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
  return new Polygon(flatCoordinates, _GeometryLayout["default"].XY, [flatCoordinates.length]);
}
/**
 * Create a polygon from an extent. The layout used is `XY`.
 * @param {import("../extent.js").Extent} extent The extent.
 * @return {Polygon} The polygon.
 * @api
 */


function fromExtent(extent) {
  var minX = extent[0];
  var minY = extent[1];
  var maxX = extent[2];
  var maxY = extent[3];
  var flatCoordinates = [minX, minY, minX, maxY, maxX, maxY, maxX, minY, minX, minY];
  return new Polygon(flatCoordinates, _GeometryLayout["default"].XY, [flatCoordinates.length]);
}
/**
 * Create a regular polygon from a circle.
 * @param {import("./Circle.js").default} circle Circle geometry.
 * @param {number} [opt_sides] Number of sides of the polygon. Default is 32.
 * @param {number} [opt_angle] Start angle for the first vertex of the polygon in
 *     counter-clockwise radians. 0 means East. Default is 0.
 * @return {Polygon} Polygon geometry.
 * @api
 */


function fromCircle(circle, opt_sides, opt_angle) {
  var sides = opt_sides ? opt_sides : 32;
  var stride = circle.getStride();
  var layout = circle.getLayout();
  var center = circle.getCenter();
  var arrayLength = stride * (sides + 1);
  var flatCoordinates = new Array(arrayLength);

  for (var i = 0; i < arrayLength; i += stride) {
    flatCoordinates[i] = 0;
    flatCoordinates[i + 1] = 0;

    for (var j = 2; j < stride; j++) {
      flatCoordinates[i + j] = center[j];
    }
  }

  var ends = [flatCoordinates.length];
  var polygon = new Polygon(flatCoordinates, layout, ends);
  makeRegular(polygon, center, circle.getRadius(), opt_angle);
  return polygon;
}
/**
 * Modify the coordinates of a polygon to make it a regular polygon.
 * @param {Polygon} polygon Polygon geometry.
 * @param {import("../coordinate.js").Coordinate} center Center of the regular polygon.
 * @param {number} radius Radius of the regular polygon.
 * @param {number} [opt_angle] Start angle for the first vertex of the polygon in
 *     counter-clockwise radians. 0 means East. Default is 0.
 */


function makeRegular(polygon, center, radius, opt_angle) {
  var flatCoordinates = polygon.getFlatCoordinates();
  var stride = polygon.getStride();
  var sides = flatCoordinates.length / stride - 1;
  var startAngle = opt_angle ? opt_angle : 0;

  for (var i = 0; i <= sides; ++i) {
    var offset = i * stride;
    var angle = startAngle + (0, _math.modulo)(i, sides) * 2 * Math.PI / sides;
    flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
    flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
  }

  polygon.changed();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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